module.exports = __webpack_public_path__ + "static/media/model_Y.bd54f90b.png";